export default (capacity) =>
  capacity?.length ? +capacity?.split(' ')[0] : capacity
